// extracted by mini-css-extract-plugin
export default {"title":"GraphActivityTitle_title__DqkSn"};